import i18n from "i18next";

export const getDataGridI18n = (t = i18n.t.bind(i18n)) => {
  const grid = t("datagrid", { returnObjects: true });
  if (!grid || typeof grid !== "object") {
    return {};
  }
  return grid;
};

export default getDataGridI18n;
